// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');



// WEBPACK FOOTER //
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.set.of.js